import styled, { css } from 'styled-components'

export const CheckboxCustom = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  min-width: 16px;
  min-height: 16px;
  height: 16px;
  border: 1px solid var(--t-checkbox-border);
  border-radius: 4px;
  transition: all 0.3s;
  background-color: var(--t-checkbox-bg);
  margin-right: 9px;
  position: relative;
  color: var(--p-neutral-100);

  svg {
    width: 8px;
    height: 8px;
    opacity: 0;
  }
`

export const CheckboxWrap = styled.label`
  display: flex;
  align-content: center;
  width: fit-content;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  ${({ $disabled }) =>
    !$disabled &&
    css`
      &:hover {
        ${CheckboxCustom} {
          border-color: var(--t-switch-border);
        }
      }
    `}
`

export const CheckboxInput = styled.input.attrs({
  type: 'checkbox',
})`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  clip: rect(0 0 0 0);

  &:checked ~ ${CheckboxCustom} {
    background-color: var(--p-blue-500);
    border-color: var(--p-blue-500);

    svg {
      opacity: 1;
    }
  }
`

const CheckboxLabelStyled = styled.span`
  color: ${({ $disabled }) =>
    $disabled ? 'var(--t-switch-label-disabled-color)' : 'var(--t-text-input)'};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
`

export const CheckboxLabel = ({ children, $disabled }) => {
  return (
    <CheckboxLabelStyled $disabled={$disabled}>{children}</CheckboxLabelStyled>
  )
}
